var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 7,
    viewBox: "0 0 10 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.36917 0.662784C9.55541 0.866669 9.5411 1.18293 9.33722 1.36917L3.86353 6.36917C3.66428 6.55118 3.35655 6.54223 3.16822 6.34895L0.641899 3.75636C0.449181 3.55858 0.45328 3.24203 0.651054 3.04931C0.848827 2.85659 1.16538 2.86069 1.3581 3.05846L3.54655 5.30432L8.66278 0.630837C8.86667 0.444596 9.18293 0.4589 9.36917 0.662784Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.af2c9d08e50437d962c4453042c1cc7b.svg";
export { ForwardRef as ReactComponent };